var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonadDarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 194 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 97,
    fill: "#200053"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 91.9806C43.2 47.9806 77.5 27.9806 92 23.4806C103 11.9806 172.5 70.4806 171 94.9806C169.5 119.481 115 175.481 92 171.481C74 164.481 22 123.981 22 91.9806Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5001 85C62.5001 72.2 93.5001 59.3333 108 54.5C121 63.5 143.5 100.5 140 109C136.5 117.5 95.0001 140.5 86.5001 140C78.0001 139.5 52.0001 102.5 54.5001 85Z",
    fill: "#200053"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonadDarkCircle);
export default __webpack_public_path__ + "static/media/MonadDarkCircle.a92c64c6de600661eb4b867267e726a4.svg";
export { ForwardRef as ReactComponent };